import { createAsyncThunk } from "@reduxjs/toolkit"

import apiClient from "src/apiClient"

import commonReducers from "../reducers"

export const thunk = createAsyncThunk("common/gameConfig", async (_, { rejectWithValue }) => {
  try {
    const gameConfig = await apiClient.get("/game-config/")
    return { gameConfig: gameConfig.data }
  } catch (error) {
    return rejectWithValue(error.response.data)
  }
})

export const onSucceed = commonReducers.setData

const thunkObject = { thunk, onSucceed }
export default thunkObject
